import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ColorPicker, Button } from '../../../../itds/elements/index.js';
import { Colors } from '../../../../itds/Theme';
import { Api } from '../../../../brokerage/utils/Api';

const ThemeOptions = ({ universal_quoter, setErrorMessage, setSuccessMessage, onReload }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    // Use primary_color and secondary_color directly from universal_quoter
    setData({
      primary_color: universal_quoter.primary_color || Colors.PRIMARY.hex,
      secondary_color: universal_quoter.secondary_color || Colors.PRIMARY.hex
    });
  }, [universal_quoter]);

  useEffect(() => {
    return () => {
      if (setErrorMessage) setErrorMessage(null);
      if (setSuccessMessage) setSuccessMessage(null);
    };
  }, []);

  const handleColorChange = color => {
    setData({ ...data, secondary_color: color.hex });
  };

  const handleSave = () => {
    // Update universal quoter with new theme colors
    Api.updateUniversalQuoter(universal_quoter.token || universal_quoter.id, {
      ...universal_quoter,
      primary_color: data.primary_color,
      secondary_color: data.secondary_color
    })
      .then(() => {
        if (setSuccessMessage) setSuccessMessage('Theme Options updated successfully');
        // Call parent reload if provided
        if (typeof onReload === 'function') onReload();
      })
      .catch(() => {
        if (setErrorMessage) setErrorMessage('Error saving Theme Options');
      });
  };

  return (
    <div>
      <ColorPicker
        color={{ hex: data.secondary_color || Colors.PRIMARY.hex }}
        label='Theme Color'
        onChange={handleColorChange}
      />
      <div style={{ marginTop: 30 }}>
        <Button inline={true} onClick={handleSave}>
          Save
        </Button>
      </div>
    </div>
  );
};

ThemeOptions.propTypes = {
  onReload: PropTypes.func,
  setErrorMessage: PropTypes.func,
  setSuccessMessage: PropTypes.func,
  universal_quoter: PropTypes.object.isRequired
};

export default ThemeOptions;
